<div class="preview" *ngIf="componentList.length !== 0">
    <div class="selected-components">
        <ng-container *ngFor="let selectedComponent of componentList; let componentIndex = index">
            <ng-container [ngSwitch]="selectedComponent">
                <div class="component">
                    <aumico-notes-rich-text
                        *ngSwitchCase="componentNames.RICH_TEXT"
                        [language]="currentLanguage"
                        [translatableTexts]="previewComponentOptions.get(selectedComponent).componentOptions"
                        [disableRichText]="true"
                        [viewMode]="viewMode"
                        [componentIndex]="componentIndex"
                    >
                    </aumico-notes-rich-text>
                </div>

                <div class="component">
                    <aumico-notes-equity
                        *ngSwitchCase="componentNames.EQUITY"
                        [editable]="false"
                        [componentOptions]="previewComponentOptions.get(selectedComponent).componentOptions[0]"
                        [viewMode]="viewMode"
                        [componentIndex]="componentIndex"
                    ></aumico-notes-equity>
                </div>

                <div class="component">
                    <aumico-notes-fli
                        *ngSwitchCase="componentNames.FINANCIAL_LINE_ITEM"
                        [componentOptions]="previewComponentOptions.get(selectedComponent).componentOptions[0]"
                        [editable]="false"
                        [viewMode]="viewMode"
                        [componentIndex]="componentIndex"
                    >
                    </aumico-notes-fli>
                </div>

                <div class="component">
                    <aumico-notes-free-table-with-amounts
                        *ngSwitchCase="componentNames.FREE_TABLE_WITH_AMOUNTS"
                        [editable]="false"
                        [componentOptions]="previewComponentOptions.get(selectedComponent).componentOptions[0]"
                        [viewMode]="viewMode"
                        [componentIndex]="componentIndex"
                    >
                    </aumico-notes-free-table-with-amounts>
                </div>

                <div class="component">
                    <aumico-notes-select
                        *ngSwitchCase="componentNames.SELECT"
                        [componentOptions]="previewComponentOptions.get(selectedComponent).componentOptions[0]"
                        [viewMode]="viewMode"
                        [componentIndex]="componentIndex"
                        [language]="currentLanguage"
                    >
                    </aumico-notes-select>
                </div>

                <div class="component">
                    <aumico-notes-input
                        *ngSwitchCase="componentNames.INPUT"
                        [componentOptions]="previewComponentOptions.get(selectedComponent).componentOptions[0]"
                        [previewMode]="true"
                        [viewMode]="viewMode"
                        [componentIndex]="componentIndex"
                    >
                    </aumico-notes-input>
                </div>

                <div class="component" *ngSwitchCase="componentNames.MOVEMENT_SCHEDULE">
                    <aumico-notes-movements-schedule
                        [data]="mockedMovementScheduleData"
                        [flis]="mockedMovementScheduleFli"
                        [componentIndex]="componentIndex"
                        [reportLocale]="currentLanguage"
                    ></aumico-notes-movements-schedule>
                </div>

                <div class="component">
                    <aumico-notes-super-table
                        *ngSwitchCase="componentNames.SUPER_TABLE"
                        [componentOptions]="previewComponentOptions.get(selectedComponent).componentOptions[0]"
                        [previewMode]="true"
                        [viewMode]="viewMode"
                    >
                    </aumico-notes-super-table>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>
